import { SVGFC } from '@repo/toolkit/types'

const FamilyTwoIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.75494 18.483C5.98619 17.9205 5.40119 16.9249 5.40119 15.9012C5.40119 14.1987 6.78682 12.813 8.48932 12.813C9.66869 12.813 10.4318 13.2218 11.0262 14.0787C11.2568 14.4105 11.5512 14.3487 11.5512 13.9868H11.5531L11.5249 13.0287C11.5249 11.3805 10.2912 10.6343 7.97932 10.6343H6.55244C4.55744 10.6343 3.29932 11.5174 3.29932 13.2462V17.958C3.29932 18.6762 3.88244 19.2593 4.60057 19.2593H5.86057C5.86432 19.2555 5.86619 19.2518 5.86994 19.248C6.09494 18.9593 6.75494 18.483 6.75494 18.483Z"
        fill={color}
      />
      <path
        d="M7.41478 9.95555C8.99087 9.95555 10.2685 8.67788 10.2685 7.1018C10.2685 5.52571 8.99087 4.24805 7.41478 4.24805C5.8387 4.24805 4.56104 5.52571 4.56104 7.1018C4.56104 8.67788 5.8387 9.95555 7.41478 9.95555Z"
        fill={color}
      />
      <path
        d="M17.3599 10.6343H15.933C13.6212 10.6343 12.3874 11.3805 12.3874 13.0287L12.3574 14.0862C12.363 14.2287 12.3968 14.3337 12.5393 14.3655C12.6968 14.4012 12.7605 14.253 12.8449 14.1218C13.4037 13.2405 14.2455 12.813 15.4249 12.813C17.1274 12.813 18.513 14.1987 18.513 15.9012C18.513 16.9249 18.0105 17.8324 17.2399 18.393C17.2399 18.393 17.8812 18.888 18.1887 19.2405C18.1943 19.2462 18.198 19.2518 18.2037 19.2574H19.3099C20.028 19.2574 20.6112 18.6743 20.6112 17.9562V13.2462C20.613 11.5174 19.353 10.6343 17.3599 10.6343Z"
        fill={color}
      />
      <path
        d="M16.4997 9.95555C18.0758 9.95555 19.3535 8.67788 19.3535 7.1018C19.3535 5.52571 18.0758 4.24805 16.4997 4.24805C14.9237 4.24805 13.646 5.52571 13.646 7.1018C13.646 8.67788 14.9237 9.95555 16.4997 9.95555Z"
        fill={color}
      />
      <path
        d="M15.3929 18.2013C16.6635 18.2013 17.6935 17.1713 17.6935 15.9007C17.6935 14.6301 16.6635 13.6001 15.3929 13.6001C14.1223 13.6001 13.0923 14.6301 13.0923 15.9007C13.0923 17.1713 14.1223 18.2013 15.3929 18.2013Z"
        fill={color}
      />
      <path
        d="M13.108 20.7687C12.9205 20.7687 12.7798 20.5906 12.8286 20.4106C13.0836 19.4787 14.1317 18.7212 15.388 18.7212C16.6498 18.7212 17.6998 19.4581 17.9511 20.4124C17.998 20.5924 17.8592 20.7706 17.6717 20.7706C17.6717 20.7687 13.108 20.7687 13.108 20.7687Z"
        fill={color}
      />
      <path
        d="M8.53109 18.2013C9.80169 18.2013 10.8317 17.1713 10.8317 15.9007C10.8317 14.6301 9.80169 13.6001 8.53109 13.6001C7.26049 13.6001 6.23047 14.6301 6.23047 15.9007C6.23047 17.1713 7.26049 18.2013 8.53109 18.2013Z"
        fill={color}
      />
      <path
        d="M6.24566 20.7686C6.05816 20.7686 5.91753 20.5905 5.96628 20.4105C6.22128 19.4786 7.26941 18.7211 8.52566 18.7211C9.78753 18.7211 10.8375 19.458 11.0888 20.4123C11.1357 20.5923 10.9969 20.7705 10.8094 20.7705C10.8094 20.7686 6.24566 20.7686 6.24566 20.7686ZM13.0463 17.7817C12.8888 17.6036 12.5025 17.5155 12.2119 17.7498C12.1032 17.838 11.9588 18.0255 11.9588 18.0255C11.9588 18.0255 11.8144 17.838 11.7057 17.7498C11.415 17.5155 11.0288 17.6036 10.8713 17.7817C10.6219 18.0648 10.6613 18.4361 10.9744 18.8205C11.4038 19.3473 11.9588 19.8498 11.9588 19.8517C11.9588 19.8517 12.5138 19.3492 12.9432 18.8205C13.2563 18.4361 13.2957 18.0648 13.0463 17.7817Z"
        fill={color}
      />
    </svg>
  )
}

export default FamilyTwoIcon
